import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterLink } from '@angular/router'
import { NotificationModule, PageComponent } from '@ftr/foundation'
import { LaunchDarklyModule } from '@ftr/ui-feature-flags'
import { IfGlobalAdminDirective } from '@ftr/ui-user'
import { ForbiddenComponent } from './forbidden.component'

@NgModule({
  imports: [CommonModule, NotificationModule, PageComponent, LaunchDarklyModule, IfGlobalAdminDirective, RouterLink],
  declarations: [ForbiddenComponent],
  exports: [ForbiddenComponent],
})
export class ForbiddenModule {}
